import { AddRoundedIcon, Box, Button, Flex, Paper, Text } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';
import { APP_PERMISSIONS } from '@user-management/permissions';
import { RoleCreationModal } from '@user-management/role-creation';
import { RoleList, RoleSearchForm } from '@user-management/role-list';

export default function RoleAndPermissionPage() {
  const [isRoleCreationModalModalOpen, roleCreationModalHandlers] = useDisclosure();
  const { open: openCreateRoleModal, close: closeCreateRoleModal } = roleCreationModalHandlers;

  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <Flex
        sx={(theme) => ({
          alignItems: 'center',
          justifyContent: 'space-between',
          p: theme.spacing(8, 6),
        })}
      >
        <Text variant='h1'>Roles and Permissions</Text>
        <WithPermission requiredPermission={APP_PERMISSIONS.SETTING.ROLE.CREATE}>
          <Button startIcon={<AddRoundedIcon />} size='large' onClick={openCreateRoleModal}>
            Create Role
          </Button>
        </WithPermission>
      </Flex>
      <Box sx={{ p: (theme) => theme.spacing(6) }}>
        <Paper
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            gap: theme.spacing(6),
            p: theme.spacing(6, 6, 0),
          })}
        >
          <Box sx={{ width: '100%', maxWidth: '318px' }}>
            <RoleSearchForm />
          </Box>
          <RoleList />
        </Paper>
      </Box>
      <RoleCreationModal open={isRoleCreationModalModalOpen} onClose={closeCreateRoleModal} />
    </Flex>
  );
}
